export var responseTypes={ENTITY:'ENTITY',COLL:'COLL',NONE:'NONE'// useful when deleting
};